<div class="notfound bg-default flex h-screen ">
    <div class="flex flex-col w-screen">
        <h1>404 - Page not found</h1>
        <p>oops... we can't find the page you were looking for.</p>
        <a [routerLink]="['/']"><mat-icon>arrow_back</mat-icon><b class="text-lg">Go back to home</b></a>
    </div>
</div>
